<div class="modal-overlay" (click)="close.emit()">
  <div class="modal" (click)="$event.stopPropagation()">

    <!-- HEADER -->
    <div class="modal-header">
      <h3 class="modal-title">{{ title }}</h3>
      <button class="btn-close" (click)="close.emit()">×</button>
    </div>

    <!-- BODY -->
    <div class="modal-body">

      <!-- Site (création uniquement) -->
      <div class="field" *ngIf="!isEdit">
        <label class="field-label">{{ 'equipements.upsertModal.site' | translate }} <span class="required">*</span></label>
        <select class="field-select"
                [ngModel]="selectedEstablishmentId"
                (ngModelChange)="onEstablishmentChange($event)"
                name="establishmentId">
          <option *ngFor="let e of sortedEstablishments" [value]="e.id">{{ e.name }}</option>
        </select>
      </div>

      <!-- Nom -->
      <div class="field" [class.field-error]="errors['name']">
        <label class="field-label">{{ 'equipements.upsertModal.name' | translate }} <span class="required">*</span></label>
        <input class="field-input"
               type="text"
               [placeholder]="'equipements.upsertModal.namePlaceholder' | translate"
               [(ngModel)]="form.name"
               name="name"
               autocomplete="off" />
        <span class="error-msg" *ngIf="errors['name']">{{ errors['name'] }}</span>
      </div>

      <!-- DevEUI -->
      <div class="field" [class.field-error]="errors['deviceEui']">
        <label class="field-label">{{ 'equipements.upsertModal.devEui' | translate }} <span class="required">*</span></label>
        <input class="field-input field-mono"
               type="text"
               placeholder="Ex. 24E124824055100B"
               [(ngModel)]="form.deviceEui"
               name="deviceEui"
               maxlength="16"
               autocomplete="off"
               (input)="form.deviceEui = form.deviceEui.toUpperCase()" />
        <span class="field-hint">{{ 'equipements.upsertModal.devEuiHint' | translate }}</span>
        <span class="error-msg" *ngIf="errors['deviceEui']">{{ errors['deviceEui'] }}</span>
      </div>

      <!-- Type de capteur -->
      <div class="field" [class.field-error]="errors['deviceType']">
        <label class="field-label">{{ 'equipements.upsertModal.deviceType' | translate }} <span class="required">*</span></label>
        <select class="field-select" [(ngModel)]="form.deviceType" name="deviceType">
          <option *ngFor="let t of deviceTypes" [value]="t.value">{{ t.label }}</option>
        </select>
        <span class="error-msg" *ngIf="errors['deviceType']">{{ errors['deviceType'] }}</span>
      </div>

      <!-- Localisation -->
      <div class="field">
        <label class="field-label">{{ 'equipements.upsertModal.location' | translate }}</label>
        <input class="field-input"
               type="text"
               [placeholder]="'equipements.upsertModal.locationPlaceholder' | translate"
               [(ngModel)]="form.location"
               name="location"
               autocomplete="off" />
        <span class="field-hint">{{ 'equipements.upsertModal.locationHint' | translate }}</span>
      </div>

      <!-- File liée -->
      <div class="field">
        <label class="field-label">{{ 'equipements.common.linkedQueue' | translate }}</label>
        <select class="field-select" [(ngModel)]="form.queueId" name="queueId">
          <option [value]="null">{{ 'equipements.upsertModal.noQueueOption' | translate }}</option>
          <option *ngFor="let q of queues" [value]="q.id">{{ q.name }}</option>
        </select>
        <span class="field-hint">{{ 'equipements.upsertModal.queueHint' | translate }}</span>
      </div>

      <!-- Actif (seulement en mode édition) -->
      <div class="field field-checkbox" *ngIf="isEdit">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="form.active" name="active" />
          <span>{{ 'equipements.upsertModal.activeCheckbox' | translate }}</span>
        </label>
        <span class="field-hint">{{ 'equipements.upsertModal.activeHint' | translate }}</span>
      </div>

    </div>

    <!-- Erreur serveur -->
    <div class="save-error" *ngIf="saveError">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ saveError }}
    </div>

    <!-- FOOTER -->
    <div class="modal-footer">
      <button class="btn-cancel" (click)="close.emit()" [disabled]="saving">{{ 'equipements.common.cancel' | translate }}</button>
      <button class="btn-save" (click)="onSubmit()" [disabled]="saving">
        <span *ngIf="!saving">{{ (isEdit ? 'equipements.common.save' : 'equipements.upsertModal.add') | translate }}</span>
        <span *ngIf="saving">{{ 'equipements.upsertModal.saving' | translate }}</span>
      </button>
    </div>

  </div>
</div>
